import { render, staticRenderFns } from "./FileSplit.vue?vue&type=template&id=f9165954&"
import script from "./FileSplit.vue?vue&type=script&lang=ts&"
export * from "./FileSplit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports